import React from "react";

const CouponVector = () => {
  return (
    <svg
      width="3"
      height="111"
      viewBox="0 0 3 111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.509007"
        y1="1.49083"
        x2="2.49083"
        y2="110.491"
        stroke="#D4D7DB"
        strokeLinecap="round"
        stroke-dasharray="5 5"
      />
    </svg>
  );
};

export default CouponVector;
